module.exports = __webpack_public_path__ + "img/22.4180c3d3.png";